



























import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse, InterpreterProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import ConfirmationBox from '../../components/ConfirmationBox.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';


@Component({
    props: {
        request: Object,
    },
    mixins: [validationMixin],
    components: {
        ConfirmationBox,
    },
    data() {
        return {
            interpreterId: '',
        };
    },
    validations: {
        interpreterId: {
            required,
        },
    },
})
export default class AssignInterpreterModal extends Vue {
    private show = true;
    private showConfirmBox = false;
    private interpreters: InterpreterProfile[] = [];
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    public async mounted() {
        await this.getInterpreterList();
    }

    private async assignInterpreter() {
        const iHttpService = ObjectFactory.getHttpService();
        const requestId = this.$props.request.id;
        const interpreterId = this.$data.interpreterId;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: {interpreterId},
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/${requestId}/assign`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<any[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'Interpreter Assigned Successfully',
                title: 'Interpreter Assigned!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }

    private async getInterpreterList(): Promise<ApiResponse<InterpreterProfile[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: [{
                    op: 'eq',
                    fieldName: 'parentInterpreterId',
                    value: this.sessionInfo.id,
                },
                {
                    op: 'eq',
                    fieldName: 'status',
                    value: 'VERIFIED',
                },
                {
                    op: 'eq',
                    fieldName: 'languages.languageName',
                    value: this.$props.request.interpreterRequest.language,
                }],
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<InterpreterProfile[]>(apiRequest);
        if (response.success && response.data) {
            this.interpreters = response.data;
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }

    private close() {
        this.$emit('close');
    }
}
